// Icon mapping: lucide-react icons
import * as Icons from 'lucide-react';

// Map icon names to lucide-react components
const iconMap: Record<string, React.ComponentType<any>> = {
  Briefcase: Icons.Briefcase,
  Users: Icons.Users,
  UserCheck: Icons.UserCheck,
  MessageSquare: Icons.MessageSquare,
  Cable: Icons.Cable,
  UserPlus: Icons.UserPlus,
  UserPlus2: Icons.UserPlus, // Alias for invite users
  Share2: Icons.Share2,
  Info: Icons.Info,
  User: Icons.User,
  Settings: Icons.Settings,
  Globe: Icons.Globe,
  HelpCircle: Icons.HelpCircle,
  TrendingUp: Icons.TrendingUp,
  TrendingDown: Icons.TrendingDown,
  Minus: Icons.Minus,
  ArrowRight: Icons.ArrowRight,
  X: Icons.X,
  Plus: Icons.Plus,
  Mail: Icons.Mail,
  Bell: Icons.Bell,
  CheckCircle: Icons.CheckCircle,
  AlertCircle: Icons.AlertCircle,
  Clock: Icons.Clock,
  Calendar: Icons.Calendar,
  MapPin: Icons.MapPin,
  DollarSign: Icons.DollarSign,
  FileText: Icons.FileText,
  Home: Icons.Home,
};

export function getIcon(iconName: string): React.ComponentType<any> {
  return iconMap[iconName] || Icons.Circle;
}

// Export commonly used icons
export const BriefcaseIcon = Icons.Briefcase;
export const UsersIcon = Icons.Users;
export const UserCheckIcon = Icons.UserCheck;
export const MessageIcon = Icons.MessageSquare;
export const PlugIcon = Icons.Cable;
export const PlusIcon = Icons.Plus;
export const ShareIcon = Icons.Share2;
export const InfoIcon = Icons.Info;
export const ArrowUpIcon = Icons.TrendingUp;
export const ArrowDownIcon = Icons.TrendingDown;
export const ArrowRightIcon = Icons.ArrowRight;
export const MessageSquareIcon = Icons.MessageSquare;
export const BellIcon = Icons.Bell;
